import { PHONE_COUNTRY_CODES } from '../../../NewIntervention/Steps/PDSSelection/phoneCountryCodes';

export type PhoneCountryOption = {
  /** Code ISO 3166-1 alpha-2, valeur portée par le select. */
  code: string;
  /** Indicatif à envoyer à l'API, par ex. « +33 ». */
  dialCode: string;
  /** Nom traduit suivi de l'indicatif, par ex. « France (+33) ». */
  label: string;
};

/** Signature minimale du `t` d'i18next, pour ne pas dépendre de ses génériques. */
type Translate = (key: string) => string;

/**
 * Construit les options d'indicatif téléphonique avec les noms de pays traduits.
 *
 * Le tri se fait sur le nom traduit, et non sur l'ordre de `PHONE_COUNTRY_CODES` :
 * cette constante est rangée par nom français, ce qui donnerait une liste
 * désordonnée dans toute autre langue.
 *
 * Le champ `label` de `PHONE_COUNTRY_CODES` est ignoré ici — il est codé en dur en
 * français et ne sert plus qu'à l'ancien écran. À supprimer avec lui.
 */
export function buildPhoneCountryOptions(t: Translate, language: string): PhoneCountryOption[] {
  return PHONE_COUNTRY_CODES.map((country) => ({
    code: country.code,
    dialCode: country.dialCode,
    label: `${t(`countries.${country.code}`)} (${country.dialCode})`
  })).sort((a, b) => a.label.localeCompare(b.label, language));
}
